import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SiteConfigService } from '../core/site-config.service';

@Component({
  selector: 'app-not-found-page',
  imports: [RouterLink],
  template: `<main class="not-found"><p>404</p><h1>Bu sayfa burada bulunmuyor.</h1><span>{{site.config().name}} için açık olan bölümlere ana sayfadan ulaşabilirsin.</span><a routerLink="/">Ana sayfaya dön</a></main>`,
  styles: [`.not-found{align-content:center;display:grid;gap:18px;justify-items:start;min-height:70svh}.not-found p{color:var(--accent);font-size:.8rem;font-weight:950;letter-spacing:.18em;margin:0}.not-found h1{font:700 clamp(3rem,9vw,8rem)/.9 Georgia,serif;letter-spacing:-.07em;margin:0;max-width:900px}.not-found span{color:var(--muted);font-size:1.08rem;line-height:1.6}.not-found a{background:var(--accent);border-radius:999px;color:var(--paper);font-weight:950;padding:14px 22px}`]
})
export class NotFoundPage { protected readonly site = inject(SiteConfigService); }
